import React from 'react';
import { Modal } from 'antd';
import intl from 'react-intl-universal';

export const errorCodeHandle = (code, error) => {
  switch (code) {
    case 12030: // 自动排房失败，无可排房间
    case 12046: // 排房失败
    case 12134: // 排房失败 msg有房型
      Modal.confirm({
        title: <b>{intl.get('cmp_error_code_handle_assign_fail_title')}</b>,
        width: 530,
        icon: null,
        content: (
          <div>
            {error.msg ? <div>{error.msg}</div> : null}
            <br />
            <div>{intl.get('cmp_error_code_handle_assign_fail_content_p1')}</div>
            <div>{intl.get('cmp_error_code_handle_assign_fail_content_p2')}</div>
            <div>{intl.get('cmp_error_code_handle_assign_fail_content_p3')}</div>
            <div>{intl.get('cmp_error_code_handle_assign_fail_content_p4')}</div>
            <br />
            {intl.get('cmp_error_code_handle_assign_fail_content_p5')}
          </div>
        ),
        okText: intl.get('app_confirm_close_btn'),
        okButtonProps: { style: { background: '#3f79ff', borderColor: '#3f79ff' } },
        cancelButtonProps: { style: { display: 'none' } },
        closable: true,
      });
      break;
    default:
      break;
  }
};
